import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { ProgressProvider } from "./context/ProgressContext";
import { AuthProvider } from "./context/AuthContext";
import AuthPage from "./pages/AuthPage";
import FamilyDashboard from "./pages/FamilyDashboard";
import Certificate from "./pages/Certificate";
import { ForgotPassword, ResetPassword } from "./pages/PasswordReset";
import StreakReminder from "./components/StreakReminder";
import AcceptInvite from "./pages/AcceptInvite";
import CertificateGallery from "./pages/CertificateGallery";
import StickerBook from "./pages/StickerBook";
import StickerSheet from "./pages/StickerSheet";
import BadgeCertificate from "./pages/BadgeCertificate";
import PhotosPage from "./pages/PhotosPage";
import ReportCard from "./pages/ReportCard";
import PrivacyPage from "./pages/PrivacyPage";
import BrandAssets from "./pages/BrandAssets";
import AdminResetDemo from "./pages/AdminResetDemo";
import StickerUnlockWatcher from "./components/StickerUnlockWatcher";
import YearInReviewWatcher from "./components/YearInReviewWatcher";
import WelcomeTour from "./components/WelcomeTour";
import OfflineBanner from "./components/OfflineBanner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import ModulesPage from "./pages/ModulesPage";
import ModuleWorld from "./pages/ModuleWorld";
import Parents from "./pages/Parents";
import About from "./pages/About";
import CreatePanda from "./pages/CreatePanda";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <AuthProvider>
        <ProgressProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Header />
            <StreakReminder />
            <StickerUnlockWatcher />
            <YearInReviewWatcher />
            <WelcomeTour />
            <OfflineBanner />
            <main className="flex-1">
            <Toaster position="bottom-right" richColors />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/lessons" element={<ModulesPage />} />
                <Route path="/lessons/:slug" element={<ModuleWorld />} />
                <Route path="/parents" element={<Parents />} />
                <Route path="/parents/:section" element={<Parents />} />
                <Route path="/about" element={<About />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/brand" element={<BrandAssets />} />
                <Route path="/admin/reset-demo" element={<AdminResetDemo />} />
                <Route path="/panda" element={<CreatePanda />} />
                <Route path="/login" element={<AuthPage />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/family" element={<FamilyDashboard />} />
                <Route path="/certificate/:slug" element={<Certificate />} />
                <Route path="/certificates" element={<CertificateGallery />} />
                <Route path="/stickers" element={<StickerBook />} />
                <Route path="/stickers/print" element={<StickerSheet />} />
                <Route path="/badge-certificate/:childId/:tier" element={<BadgeCertificate />} />
                <Route path="/photos" element={<PhotosPage />} />
                <Route path="/report-card/:childId" element={<ReportCard />} />
                <Route path="/invite/accept" element={<AcceptInvite />} />
              </Routes>
            </main>
            <Footer />
          </BrowserRouter>
        </ProgressProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
